import VideoGrid from "@/components/editor/shared/media/video-grid/video-grid-component";
import Benefits from "@/components/editor/shared/sections/benefits/benefits-component";
import BoothCard from "@/components/editor/themes/crosby/blocks/expo/booth-card/booth-card-component";
import Booths from "@/components/editor/themes/crosby/blocks/expo/booths-component";
import SyncedBooths from "@/components/editor/themes/crosby/blocks/expo/synced-booths-component";
import HeaderOption1 from "@/components/editor/themes/crosby/blocks/headers/header-option-1/header-option-1-component";
import HeaderOption2 from "@/components/editor/themes/crosby/blocks/headers/header-option-2/header-option-2-component";
import HeaderOption3 from "@/components/editor/themes/crosby/blocks/headers/header-option-3/header-option-3-component";
import HeaderOption4 from "@/components/editor/themes/crosby/blocks/headers/header-option-4/header-option-4-component";
import StandaloneNavigation from "@/components/editor/themes/crosby/blocks/headers/standalone-navigation/standalone-navigation-component";
import VideoWithParagraph from "@/components/editor/themes/crosby/blocks/media/video-with-paragraph/video-with-paragraph-component";
import VideoWithTitle from "@/components/editor/themes/crosby/blocks/media/video-with-title/video-with-title-component";
import DefaultSchedule from "@/components/editor/themes/crosby/blocks/schedules/default-schedule-component";
import SyncedDefaultSchedule from "@/components/editor/themes/crosby/blocks/schedules/synced-default-schedule-component";
import AboutDetails from "@/components/editor/themes/crosby/blocks/sections/about-details/about-details-component";
import BenefitCard from "@/components/editor/themes/crosby/blocks/sections/benefits/benefit-card/benefit-card-component";
import Divider from "@/components/editor/themes/crosby/blocks/sections/divider/divider-component";
import DividerPicture from "@/components/editor/themes/crosby/blocks/sections/divider-picture/divider-picture-component";
import Gallery from "@/components/editor/themes/crosby/blocks/sections/gallery";
import ParagraphItem from "@/components/editor/themes/crosby/blocks/sections/paragraph-picture/paragraph-item-component";
import ParagraphPicture from "@/components/editor/themes/crosby/blocks/sections/paragraph-picture/paragraph-picture-component";
import RichTextSection from "@/components/editor/themes/crosby/blocks/sections/rich-text-section/rich-text-section-component";
import SpeakerCard from "@/components/editor/themes/crosby/blocks/speakers/speaker-card/speaker-card-component";
import SyncedSpeakerCard from "@/components/editor/themes/crosby/blocks/speakers/speaker-card/synced-speaker-card-component";
import Speakers from "@/components/editor/themes/crosby/blocks/speakers/speakers-component";
import SyncedSpeakers from "@/components/editor/themes/crosby/blocks/speakers/synced-speakers-component";
import SponsorCard from "@/components/editor/themes/crosby/blocks/sponsors/sponsor-card/sponsor-card-component";
import Sponsors from "@/components/editor/themes/crosby/blocks/sponsors/sponsors-component";
import SyncedSponsors from "@/components/editor/themes/crosby/blocks/sponsors/synced-sponsors-component";
import RelatedEventsSection from "@/components/editor/themes/hazel/blocks/sections/related-events";

const blocks = {
  AboutDetails,
  BenefitCard,
  Benefits,
  BoothCard,
  Booths,
  DefaultSchedule,
  Divider,
  DividerPicture,
  Gallery,
  HeaderOption1,
  HeaderOption2,
  HeaderOption3,
  HeaderOption4,
  ParagraphItem,
  ParagraphPicture,
  RelatedEventsSection,
  RichTextSection,
  SpeakerCard,
  Speakers,
  SponsorCard,
  Sponsors,
  StandaloneNavigation,
  SyncedBooths,
  SyncedDefaultSchedule,
  SyncedSpeakerCard,
  SyncedSpeakers,
  SyncedSponsors,
  VideoGrid,
  VideoWithParagraph,
  VideoWithTitle,
};

export default blocks;
